import Vue from 'vue';
import VueRouter from 'vue-router';
import List from '../views/List.vue';
import Page404 from '../views/Page404';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'List',
    component: List
  },
  { path: '/:id', name: 'Item', component: () => import('../views/Item.vue') },
  { path: '*', name: 'Page404', component: Page404 }
];

const router = new VueRouter({
  mode: 'history',
  base: 'news', // process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return {
      x: 0,
      y: 0,
      behavior: 'smooth'
    };
  }
});

export default router;
